module.exports = __webpack_public_path__ + "static/media/car-crash.ccaf607a.svg";